import { AVIFHeadText } from 'global-styles';
import styled from 'styled-components';

export const AVIFHeadTextComponent = styled(AVIFHeadText)`
  display: block;
  padding: 32px 0 24px;
`;
